
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/qr",
      function () {
        return require("private-next-pages/qr/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/qr"])
      });
    }
  